import { render, staticRenderFns } from "./adventuresBookings.vue?vue&type=template&id=3c165fa4"
import script from "./adventuresBookings.vue?vue&type=script&lang=js"
export * from "./adventuresBookings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports